module.exports = __webpack_public_path__ + "img/1557614097356365825.40a79997.png";